/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ecommerce/039-filter': {
    width: 512,
    height: 512,
    viewBox: '0 0 512.013 512.013',
    data: '<path pid="0" d="M463.085 0H48.929c-19.31 0-30.661 21.763-19.597 37.599.213.302-6.556-8.916 158.032 215.117a31.666 31.666 0 015.643 18.089v215.917c0 20.996 24.069 32.577 40.39 20.227l70.154-52.884c9.68-7.188 15.456-18.67 15.456-30.73v-152.53c0-6.496 1.95-12.747 5.643-18.089C489.111 28.855 482.469 37.899 482.682 37.599 493.741 21.77 482.403 0 463.085 0zM300.357 235.111c-6.801 9.257-11.35 22.164-11.35 35.693v152.529a8.312 8.312 0 01-3.355 6.655c-1.847 1.361 12.142-9.153-62.645 47.223V270.805c0-12.726-3.853-24.968-11.142-35.402-.181-.259 4.898 6.659-103.142-140.402H403.29zM425.33 65H86.684L60.971 30h390.072z"/>'
  }
})
